import { render } from "./MainLots.vue?vue&type=template&id=6b2d8f55&scoped=true"
import script from "./MainLots.vue?vue&type=script&lang=js"
export * from "./MainLots.vue?vue&type=script&lang=js"

import "./MainLots.vue?vue&type=style&index=0&id=6b2d8f55&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2d8f55"]])

export default __exports__